/* error code returned when performing an action forbidden to inactive users */
export const FORBIDDEN_INACTIVE_CODE = 403030100;



// WEBPACK FOOTER //
// ./account/constants.js